import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import {
  Station,
  StationsFilter
} from '../../types';

export const getFilteredStations = createReduxAsyncThunk<Station['code'][], StationsFilter | undefined>(
  `${STATIONS_STATE}/getFilteredStations`,
  async (filter) => {
    const { data } = await stationsAPI.getFilteredStationCodes(filter);
    return data;
  }
);
